import {FETCH_INFORMATION_REQUEST, FETCH_INFORMATION_SUCCES, FETCH_INFORMATION_ERROR} from '../constants/Information'
import { jsonGet, errorHandler } from '../utils/Request';

const loadInformation = () => (dispatch) => {
  const apiUrl = '/company/information/';
  dispatch({
    type: FETCH_INFORMATION_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_INFORMATION_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_INFORMATION_ERROR
      });
      errorHandler(e);
    });
};

export { loadInformation };



// WEBPACK FOOTER //
// ./src/actions/InformationActions.js